/****************************************************************************
 * Copyright 2018 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/

// import { fromAtomsAttrs } from '../actions/atom';

function IupacTool(editor) {
  if (!(this instanceof IupacTool)) {
    return new IupacTool(editor)
  }
  this.editor = editor
  // this.editor.selection(null);
}

IupacTool.prototype.mousemove = function (event) {
  // this.editor.hover(this.editor.findItem(event, ['atoms']));
}

IupacTool.prototype.click = function (event) {}

export default IupacTool
